import React from 'react'
import mb from './photolic/bimashree.jpg'
import './image.css'
const Shree = () => {
  return (
    <div>
      <img src={mb} alt="" className='eimg'/>
    </div>
  )
}

export default Shree
